import React, { useEffect, useState } from "react";
import "./SingleProperty.css";
import Header2 from "../../Layout/Header2";
import { useLocation, useNavigate } from "react-router-dom";
import HomeService from "../../Services/HomeService";
import arrow2 from "../../Images/Vector (11).png";
import whatsapp from "../../Images/Group 534.png";
import heart from "../../Images/Vector (10).png";
import redHeart from "../../Images/red-heart.png";
import avatar from "../../Images/avatar.png";
import { toast } from "react-toastify";
import RemarksPopup from "../PropertyList/RemarksPopup";
import ReportPropertyPopUp from "../PropertyList/ReportPropertyPopUp";
import { IoMdMail } from "react-icons/io";
import { CiMail } from "react-icons/ci";

const tabs = [
  "Overview",
  "Society",
  "Dealer Details",
  "Price Trends",
  "Explore Locality",
  "Recommendations",
];
const places = [
  "National Highway 48",
  "RPS International School",
  "SGT University",
  "DLF Cyber City",
];
const SingleProperty = () => {
  const [activeTab, setActiveTab] = useState("Overview");
  const [propertyByLocality, setPropertyByLocality] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [isRemarksOpen, setIsRemarksOpen] = useState(false);
  const [isReportPropertyPopUpOpen, setIsReportPropertyPopUpOpen] =
    useState(false);
  const [propertyIdForReportProperty, setPropertyIdForReportProperty] =
    useState("");
  // const location = useLocation();
  // const property = location?.state?.property;
  // console.log("Single Property", property);
  const [property, setProperty] = useState({});

  const [profile, setProfile] = useState({});

  const getProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      console.log("YTR60", response.data);

      if (response?.status) {
        setProfile(response.data);
      } else {
        console.error("Failed to fetch profile data");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const fetchPropertyById = async () => {
    try {
      const res = await HomeService?.getPropertyById(
        localStorage.getItem("propertyId"),
      );
      console.log("Property Details", res);
      if (res?.status) {
        setProperty(res?.data);
        console.log("property", res?.data);
      } else {
        toast?.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPropertyById();
    getProfile();
  }, []);

  const firstPhoto = property?.images?.find((url) =>
    /\.(jpg|jpeg|png|webp)$/i.test(url),
  );
  const formatDate = (isoDateString) => {
    if (!isoDateString) return "";

    const date = new Date(isoDateString);

    // Check if date is valid
    if (isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    // Add ordinal suffix to day
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month} ${year}`;
  };
  const parts = [
    property?.aptName,
    property?.locality?.name,
    property?.city?.name,
    property?.address,
  ].filter(Boolean);
  const fullAddress = parts.join(", ");

  const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    fullAddress,
  )}`;

  const fetchPropertyByLocality = async () => {
    try {
      const res = await HomeService.getPropertiesByLocality(
        property?.locality?._id,
      );
      console.log("Property by locality", res);
      if (res?.status) {
        if (res?.data?.length > 4) {
          setPropertyByLocality(res?.data?.slice(0, 4));
        } else {
          setPropertyByLocality(res?.data);
        }
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPropertyByLocality();
    window.scroll(0, 0);
  }, []);

  // const handleShareClick = (property) => {
  //   const subject = `${property.propertytype?.propertyType} in ${property.locality?.name}`;
  //   const body =
  //     `I am interested in the ${property.propertytype?.propertyType} at ${property.address}.` +
  //     `%0D%0AFound information from Winners`;

  //   const mailtoLink = `mailto:?subject=${encodeURIComponent(
  //     subject,
  //   )}&body=${body}`;

  //   const link = document.createElement("a");
  //   link.href = mailtoLink;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleShareClick = (property) => {
    const subject = `${property.propertytype?.propertyType || ""} in ${property.locality?.name || ""}`;
    const body =
      `Hello Sir/Madam,\n\n` +
      `I saw your property on the Winners Real Estate Data Portal. I am interested in your ${property?.propertyType || "property"} at ${property?.address} \n\n` +
      `Broker Details:\n` +
      `${profile?.fullName} | ${profile?.companyName} \n` +
      `${profile?.businessField} | ${profile?.majorLocality} \n` +
      `Experience : ${profile?.workExpYear}\n` +
      `📞 : ${profile?.mobileNo}\n` +
      `✉ : ${profile?.email}\n` +
      `📌 : ${profile?.address}\n` +
      `Thank You \n` +
      `Website link: https://www.thewinners2.in/\n` +
      `Download link (Android App): https://play.google.com/store/apps/details?id=com.winners.properties`;

    // Gmail direct compose URL
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}&to=`;

    window.open(gmailComposeUrl, "_blank");
  };

  // const openWhatsAppLink = (e, phoneNumber, textMessage) => {
  //   e.preventDefault();
  //   const isMobile =
  //     /iPhone|Android|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //       navigator.userAgent
  //     );
  //   const encodedText = encodeURIComponent(textMessage);
  //   const link = isMobile
  //     ? `https://wa.me/${phoneNumber}?text=${encodedText}`
  //     : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;

  //   // Create an <a> element and simulate a click
  //   const a = document.createElement("a");
  //   a.href = link;
  //   a.target = "_blank";
  //   a.rel = "noopener noreferrer";
  //   a.click();
  // };

  const openWhatsAppLink = (e, phoneNumber, textMessage) => {
    e.preventDefault();

    const encodedText = encodeURIComponent(textMessage);

    const link = `https://wa.me/${phoneNumber}?text=${encodedText}`;

    window.open(link, "_blank");
  };

  const handleRemarksSubmit = async (id) => {
    console.log("data", remarks);
    if (!remarks) {
      console.log("hi");
      toast?.error("Remarks is empty!");
      return;
    }
    try {
      const res = await HomeService.addRemarks({
        propertyId: id,
        remarks,
      });
      if (res?.status) {
        toast.success(res.message);
      } else {
        toast.error(res.message || "Error while adding Remarks!");
      }
    } catch (error) {
      console.error("Error While adding Remarks!");
    }
    setRemarks("");
  };

  const onCloseRemarks = () => {
    setIsRemarksOpen(false);
  };
  const closeReportPropertyPopUp = () => {
    setIsReportPropertyPopUpOpen(false);
  };

  const [userId, setUserId] = useState("");
  const navigate = useNavigate();
  const getLoginProfile = async () => {
    try {
      console.log("Getting login profile...");
      const res = await HomeService.getLoginProfile();
      console.log("Login profile response:", res);

      if (!res.status) {
        navigate("/profile");
        return;
      }
      if (res?.status) {
        const userData = res.data;
        setUserId(userData?._id);
      }
    } catch (error) {
      console.error("Error in getLoginProfile:", error);
      toast.error("Failed to load user profile");
    }
  };

  useEffect(() => {
    getLoginProfile();
  });

  const handleClick = async (propertyId) => {
    if (!userId) {
      toast.error("User not logged in");
      return;
    }

    // setFavPropertyId(propertyId);
    try {
      const data = { userId, propertyId };
      const res = await HomeService.addToWishList(data);
      if (res?.status) {
        toast.success(res?.message);
        setProperty((prev) => ({ ...prev, isFavorite: !prev?.isFavorite }));
      } else {
        toast.error(res?.message || "Failed to add to wishlist");
      }
    } catch (error) {
      console.error("Error adding property to wishlist:", error);
      toast.error("Failed to add property to wishlist");
    }
  };

  return (
    <div className="pageContainer-ps">
      <Header2 />

      <div className="contentWrapper-ps">
        {/* LEFT SIDE */}
        <div className="leftSection-ps">
          <div className="property-wrp">
            <div className="propertyHeaderCard-ps">
              <div className="priceBox-ps">
                <span className="featuredTag-ps">Featured</span>
                <div className="price-est-wrp">
                  <h2 className="priceValue-ps">
                    ₹{property?.price || ""}{" "}
                    <span>
                      {property?.priceUnit === "TH"
                        ? "Thousand"
                        : property?.priceUnit === "CR"
                          ? "Crore"
                          : property?.priceUnit === "LKH"
                            ? "Lakh"
                            : ""}
                    </span>
                  </h2>
                  {/* <p className="priceSub-ps">@ 2,19,702 per sq.yards</p> */}
                </div>
                {/* <p className="emiText-ps">Estimated EMI ₹4,72,034</p> */}
              </div>

              <div className="propertyInfo-ps">
                <h3 className="propertyTitle-ps">
                  {/* Residential Land/Plot for Sale */}
                  {property?.propertytype?.propertyType || ""} Property for{" "}
                  {property?.propertyFor || ""}
                </h3>
                <p className="propertyLocation-ps">
                  {/* in DLF Gardencity, Sector 91, Gurgaon */}
                  in {property?.locality?.name || ""},{" "}
                  {property?.city?.name || ""}
                </p>
              </div>
            </div>
            <div className="rera-container-ps">
              <div className="rera-left-ps">
                <span className="rera-icon-ps">
                  <i className="fa-regular fa-circle-check"></i>
                </span>
                <span className="rera-title-ps">RERA STATUS</span>

                <span className="rera-tag-ps">REGISTERED</span>

                <span className="rera-reg-ps">
                  Registration No: GGM/455/187/2021/23 DATED 15.06.2021
                </span>
              </div>

              {/* <div className="rera-right-ps">
                <a
                  href="https://haryanarera.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rera-link-ps"
                >
                  Website: https://haryanarera.gov.in/
                </a>
              </div> */}
            </div>
            <div className="property-tabs">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`tab-item ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>

          {/* MAP + PLOT BOX */}
          <div className="property-box-ps">
            <div className="property-image-wrap-ps">
              <img
                style={{ height: "200px" }}
                src="data:image/jpeg;base64,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"
                // src={firstPhoto || ""}
                alt="Hello"
                className="property-image-ps"
              />

              <div className="property-badge-ps">
                ● 2 people already contacted this week
              </div>
            </div>

            <div className="property-info-ps">
              {/* Categories */}
              {/* <div className="property-tabs-ps">
                <span className="property-tab-active-ps">Property (1)</span>
                <span className="property-tab-ps">Society (20)</span>
              </div> */}

              {/* Dimensions */}
              <div className="property-title-group-ps">
                <span className="property-icon-ps">◑</span>
                <span className="property-subtitle-ps">Dimensions</span>
              </div>

              <h3 className="property-title-ps">
                Property area {property?.area || ""} {property?.unit || ""}{" "}
                <span className="unit-ps">sq.yards</span>
              </h3>
              <p className="property-small-ps">(224.92 sq.m.)</p>

              {/* <p className="property-dimensions-ps">
                L × B : <b>30.00 ft.</b>{" "}
                <span className="dim-gray-ps">(9.14 mt.)</span> ×{" "}
                <b>21.00 ft.</b> <span className="dim-blue-ps">(6.40 mt.)</span>
              </p> */}

              {/* Bottom Row */}
              <div className="property-bottom-grid-ps">
                <div>
                  <div className="bottom-label-ps">
                    <i className="fa-solid fa-location-dot"></i> Address
                  </div>
                  <div className="bottom-value-ps">
                    {property?.address || ""}
                  </div>
                  {/* <div className="bottom-subvalue-ps">Sector 91, Gurgaon</div> */}
                </div>

                <div>
                  <div className="bottom-label-ps">
                    <i className="fa-solid fa-circle-check"></i> Authority
                    approved
                  </div>
                  <div className="bottom-value-ps">Yes</div>
                </div>
              </div>
            </div>
          </div>

          <div className="places-card">
            <div className="places-header">
              <div className="places-title">
                <div className="location-icon">
                  <i className="fa-solid fa-location-dot"></i>
                </div>

                <div>
                  <h3>Places nearby</h3>
                  <p>Block A, Sector 91, Gurgaon</p>
                </div>
              </div>

              <a href="/" className="view-all">
                View All (7)
              </a>
            </div>

            <div className="places-body">
              {places.map((place, index) => (
                <div key={index} className="place-chip">
                  <i className="fa-solid fa-building"></i>
                  {place}
                </div>
              ))}

              {/* Arrow Button */}
              <button className="arrow-btn">
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <div className="property-details-box-pd">
            <h3 className="property-details-title-pd">Property Details</h3>

            <div className="property-details-grid-pd">
              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  Transaction Type{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">Resale</span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  Property Ownership{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">{property?.contactType}</span>
              </div>

              {/* <div className="pd-item-pd">
                <span className="pd-label-pd">
                  Width of facing road{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">40.0 Feet</span>
              </div> */}

              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  Gated Community{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">Yes</span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  Boundary Wall{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">No</span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  Property Code{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">L85869268</span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  No. of Open sides{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">1</span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  Approved By{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-info opacity-50"
                    aria-hidden="true"
                    data-replit-metadata="client/src/pages/property-details.tsx:230:42"
                    data-component-name="Info"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                  </svg>
                </span>
                <span className="pd-value-pd">HUDA</span>
              </div>
            </div>
          </div>
          {/* <div className="property-details-box-pd">
            <h3 className="property-details-title-pd">Property Details</h3>

            <div className="property-details-grid-pd">
              <div className="pd-item-pd">
                <span className="pd-label-pd">Locality</span>
                <span className="pd-value-pd">
                  {property?.locality?.name || "N/A"}
                </span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">Address</span>
                <span className="pd-value-pd">
                  {" "}
                  {property.address || "N/A"}
                  {property?.newEntry || ""}
                </span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">Area</span>
                <span className="pd-value-pd">
                  {" "}
                  {property.area || "N/A"} {property?.unit || ""}
                </span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">Age</span>
                <span className="pd-value-pd">{property.age || "N/A"}</span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">Facing</span>
                <span className="pd-value-pd">
                  {property?.facing?.facing || "N/A"}
                </span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">Listed By</span>
                <span className="pd-value-pd">
                  {formatDate(property?.date) || "N/A"}
                </span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">Floor:</span>
                <span className="pd-value-pd">{property?.floor}</span>
              </div>

              <div className="pd-item-pd">
                <span className="pd-label-pd">
                  {property?.contactType || ""} Name
                </span>
                <span className="pd-value-pd">{property.name || "N/A"}</span>
              </div>
              <div className="pd-item-pd">
                <span className="pd-label-pd">Type</span>
                <span className="pd-value-pd">
                  {property?.propertytype?.propertyType || "N/A"}
                </span>
              </div>
              <div className="pd-item-pd">
                <span className="pd-label-pd">For</span>
                <span className="pd-value-pd">
                  {property.propertyFor || "N/A"}
                </span>
              </div>
              <div className="pd-item-pd">
                <span className="pd-label-pd">Contact</span>
                <span className="pd-value-pd">{property.phoneNo || "N/A"}</span>
              </div>
              <div className="pd-item-pd">
                <span className="pd-label-pd">BHK</span>
                <span className="pd-value-pd">{property?.bhk || ""}</span>
              </div>
              <div className="pd-item-pd">
                <span className="pd-label-pd">Extra</span>
                <span className="pd-value-pd">{property.extra || "N/A"}</span>
              </div>
              <div className="pd-item-pd">
                <span className="pd-label-pd">Location</span>
                <span className="pd-value-pd">
                  {property?.locationUrl ? (
                    <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                      <a
                        href={property?.locationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          class="fa-solid fa-location-dot"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </a>
                    </span>
                  ) : (
                    <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                      <a
                        href={mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          class="fa-solid fa-location-dot"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </a>
                    </span>
                  )}
                </span>
              </div>
            </div>
          </div> */}
          <div className="property-details-box-pd">
            <div style={{ marginTop: "15px" }}>
              <label style={{ fontWeight: "600" }}>Remark</label>
              <span
                style={{
                  fontWeight: "600",
                  color: "blue",
                  marginLeft: "15px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setIsRemarksOpen(true);
                }}
              >
                (Show Remarks)
              </span>
              <input
                value={remarks}
                onChange={(e) => {
                  setRemarks(e?.target?.value);
                }}
                placeholder="Type something for your own use"
                style={{
                  width: "100%",
                  height: "2.5rem",
                  borderRadius: "5px",
                  border: "1px solid #e1eaf2",
                  padding: "0 5px",
                }}
              ></input>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <button
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    borderRadius: "5px",
                    marginTop: "5px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => {
                    handleRemarksSubmit(property._id);
                    setRemarks("");
                  }}
                >
                  Submit
                </button>
                {isRemarksOpen && (
                  <RemarksPopup
                    remarksArray={property?.remarksArray}
                    onClose={onCloseRemarks}
                  />
                )}
                <label
                  style={{
                    marginTop: "5px",
                    color: "#fa2d48",
                    cursor: "pointer",
                    fontWeight: "500",
                  }}
                  onClick={() => {
                    setPropertyIdForReportProperty(property?._id);
                    setIsReportPropertyPopUpOpen(true);
                  }}
                >
                  Report This Property
                </label>
                <div
                  className="d-flex"
                  style={{ columnGap: "12px", cursor: "pointer" }}
                >
                  <div
                    className="icon_1_div"
                    onClick={() => handleClick(property._id)}
                  >
                    <img
                      src={property?.isFavorite ? redHeart : heart}
                      alt="Favorite"
                    />
                  </div>
                  <div
                    className="icon_1_div"
                    style={{ cursor: "pointer" }}
                    onClick={(e) =>
                      openWhatsAppLink(
                        e,
                        `91${property.phoneNo?.slice(0, 10)}`,
                        // `Hi ${property.name}, I am interested in your ${property.propertytype?.propertyType} at ${property.address}, ${property.locality?.name}`,
                        `Hello Sir/Madam,\n\n` +
                        `I saw your property on the Winners Real Estate Data Portal. I am interested in your ${property?.propertyType || "property"} at ${property?.address} \n\n` +
                        `Broker Details:\n` +
                        `${profile?.fullName} | ${profile?.companyName} \n` +
                        `${profile?.businessField} | ${profile?.majorLocality} \n` +
                        `Experience : ${profile?.workExpYear}\n` +
                        `Phone : ${profile?.mobileNo}\n` +
                        `Email : ${profile?.email}\n` +
                        `Address : ${profile?.address}\n` +
                        `Thank You \n` +
                        `Website link: https://www.thewinners2.in/\n` +
                        `Download link (Android App): https://play.google.com/store/apps/details?id=com.winners.properties`,
                      )
                    }
                  >
                    <img src={whatsapp} alt="WhatsApp" />
                  </div>
                  <div
                    className="icon_1_div"
                    onClick={() => handleShareClick(property)}
                  >
                    {/* <IoMdMail style={{ color: "#ba0502", fontSize: "20px" }} /> */}
                    {/* <img src={arrow2} alt="Share" /> */}
                    <CiMail
                      style={{
                        color: "#ba0502",
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about-box-ap">
            <h3 className="about-title-ap">About Property</h3>

            <p className="about-address-ap">
              <strong>Address:</strong> Block A, Sector 91, Gurgaon
            </p>

            <p className="about-text-ap">
              269 sq yard plot is available for sale in dlf garden city sector
              91 gurgaon, a gated township is being developed by dlf group. This
              property offers excellent connectivity to NH-8, IMT Manesar, and
              Pataudi Road. Surrounded by lush greenery and premium residential
              complexes like DLF New Town Heights.
            </p>

            <p className="about-text-ap">
              Ideal for building your dream home in a secure, well-planned
              environment with world-class amenities nearby including schools,
              hospitals, and shopping complexes.
            </p>

            <a href="#" className="about-readmore-ap">
              Read More
            </a>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="rightSection-ps">
          {/* DEALER CARD */}
          <div className="dealer-card-box-dl">
            <div className="dealer-info-dl">
              <img
                // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSofEItLKAdmvCrg1fYGpXXIGfX03K4GVJm6ofHpvZXaZ6-s9DPkmcjAMA&s"
                src={avatar}
                className="dealer-img-dl"
              />

              <div className="dealer-text-dl">
                {/* <p className="dealer-company-dl">GK REAL ESTATE</p> */}
                <h3 className="dealer-name-dl">{property?.name}</h3>

                <span
                  className="dealer-badge-dl"
                  style={{ textAlign: "center" }}
                >
                  {property?.contactType}
                </span>

                <p className="dealer-since-dl">Member Since Oct 2021</p>
              </div>
            </div>

            <button className="dealer-contact-btn-dl">
              Contact {property?.contactType}{" "}
              <span className="dealer-free-dl">FREE</span>
            </button>
          </div>

          <div className="tip-card-tc">
            <div className="tip-badge-tc">99 TIP</div>

            <h3 className="tip-title-tc">Properties you can trust</h3>

            <p className="tip-desc-tc">
              Properties in DLF Gardencity are RERA approved.
              <br />
              Now, buy with confidence!
            </p>

            <div className="tip-link-tc">View Price Details &gt;</div>
          </div>

          {/* MORE SECTION */}
          <div class="more-sec91">
            <h3 class="heading-dc">More in {property?.locality?.name}</h3>

            {propertyByLocality?.length === 0 ? (
              <div class="property-card-dc">
                {/* <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJ6Pd1wMuv7nKtspwQ_Qi6BEp2l5xE8735kw&s"
                class="prop-img-dc"
                alt=""
              /> */}
                <div class="prop-info-dc">
                  <h4 class="prop-title-dc">No Property Found</h4>
                  {/* <p class="prop-loc-dc">DLF New Town Heights</p> */}
                  {/* <p class="prop-price-dc">₹ 1.85 Cr</p> */}
                </div>
              </div>
            ) : (
              propertyByLocality?.map((e, i) => {
                return (
                  <div class="property-card-dc">
                    <img
                      // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJ6Pd1wMuv7nKtspwQ_Qi6BEp2l5xE8735kw&s"
                      src={
                        e?.images?.find((url) =>
                          /\.(jpg|jpeg|png|webp)$/i.test(url),
                        ) || ""
                      }
                      class="prop-img-dc"
                      alt=""
                    />
                    <div class="prop-info-dc">
                      <h4 class="prop-title-dc">
                        Property For {e?.propertyFor || ""}
                      </h4>
                      <p class="prop-loc-dc">{e?.address || ""}</p>
                      <p class="prop-price-dc">
                        ₹{e?.price || ""} {e?.priceUnit || ""}
                      </p>
                    </div>
                  </div>
                );
              })
            )}

            <div class="property-card-dc">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJ6Pd1wMuv7nKtspwQ_Qi6BEp2l5xE8735kw&s"
                class="prop-img-dc"
                alt=""
              />
              <div class="prop-info-dc">
                <h4 class="prop-title-dc">3 BHK Apartment</h4>
                <p class="prop-loc-dc">DLF New Town Heights</p>
                <p class="prop-price-dc">₹ 1.85 Cr</p>
              </div>
            </div>

            <div class="property-card-dc">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJ6Pd1wMuv7nKtspwQ_Qi6BEp2l5xE8735kw&s"
                class="prop-img-dc"
                alt=""
              />
              <div class="prop-info-dc">
                <h4 class="prop-title-dc">3 BHK Apartment</h4>
                <p class="prop-loc-dc">DLF New Town Heights</p>
                <p class="prop-price-dc">₹ 1.85 Cr</p>
              </div>
            </div>
            <div class="property-card-dc">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJ6Pd1wMuv7nKtspwQ_Qi6BEp2l5xE8735kw&s"
                class="prop-img-dc"
                alt=""
              />
              <div class="prop-info-dc">
                <h4 class="prop-title-dc">3 BHK Apartment</h4>
                <p class="prop-loc-dc">DLF New Town Heights</p>
                <p class="prop-price-dc">₹ 1.85 Cr</p>
              </div>
            </div>
            <div class="property-card-dc">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJ6Pd1wMuv7nKtspwQ_Qi6BEp2l5xE8735kw&s"
                class="prop-img-dc"
                alt=""
              />
              <div class="prop-info-dc">
                <h4 class="prop-title-dc">3 BHK Apartment</h4>
                <p class="prop-loc-dc">DLF New Town Heights</p>
                <p class="prop-price-dc">₹ 1.85 Cr</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isReportPropertyPopUpOpen && (
        <ReportPropertyPopUp
          id={propertyIdForReportProperty}
          onClose={closeReportPropertyPopUp}
        />
      )}
    </div>
  );
};

export default SingleProperty;
